import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingDocuments: false,
  isFetchingCaseLetterInfo: false,

  result: [],
};

const eligibilityCaseDocReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_MEMBERS_AND_CASE_DOCUMENTS_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_MEMBERS_AND_CASE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_MEMBERS_AND_CASE_DOCUMENTS_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_CASE_DOCUMENT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingDocuments: true,
      };

    case types.GET_CASE_DOCUMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingDocuments: false,
      };

    case types.GET_CASE_DOCUMENT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingDocuments: false,
      };

    case types.GET_CASE_LETTER_INFO_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCaseLetterInfo: true,
      };

    case types.GET_CASE_LETTER_INFO_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCaseLetterInfo: false,
      };

    case types.GET_CASE_LETTER_INFO_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCaseLetterInfo: false,
      };

    default:
      return state;
  }
};

export default eligibilityCaseDocReducer;
